const RELOAD_KEY = 'fulbito-stale-asset-reload';

const CHUNK_LOAD_PATTERNS = [
  /failed to fetch dynamically imported module/i,
  /loading chunk [\w-]+ failed/i,
  /importing a module script failed/i,
  /error loading dynamically imported module/i,
];

export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);
  return CHUNK_LOAD_PATTERNS.some((pattern) => pattern.test(message));
}

function reloadOnceForStaleAssets(): void {
  if (sessionStorage.getItem(RELOAD_KEY)) {
    return;
  }
  sessionStorage.setItem(RELOAD_KEY, '1');
  window.location.reload();
}

/** Recover from stale cached bundles after a deploy (auto-reload once). */
export function setupDeploymentRecovery(): void {
  window.addEventListener('load', () => {
    sessionStorage.removeItem(RELOAD_KEY);
  });

  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    reloadOnceForStaleAssets();
  });

  window.addEventListener('unhandledrejection', (event) => {
    if (isChunkLoadError(event.reason)) {
      event.preventDefault();
      reloadOnceForStaleAssets();
    }
  });
}
